import { createIcon } from '@chakra-ui/react';

export const OnOutlineHome = createIcon({
  path: (
    <>
      <path
        d="M3.3335 13V7.75529C3.3335 7.47661 3.44978 7.21058 3.65433 7.02131L7.32099 3.62845C7.70431 3.27376 8.29602 3.27376 8.67933 3.62845L12.346 7.02131C12.5505 7.21058 12.6668 7.47661 12.6668 7.75529V13"
        fill="transparent"
        stroke="currentColor"
        strokeLinecap="square"
      />
      <path
        d="M6.28564 13V10C6.28564 9.44772 6.73336 9 7.28564 9H8.61898C9.17126 9 9.61898 9.44772 9.61898 10V13"
        fill="transparent"
        stroke="currentColor"
        strokeLinecap="square"
      />
    </>
  ),
});
